import { DebugLogger, LocalStorage } from "@ng-mw/shared-react-components"
import NativeEventBridge from "@ng-mw/shared-react-components/src/data/NativeEventBridge"
// packages/shared-react-components/src/data/NativeEventBridge
import MenyNativeEvent from "@app/events/MenyNativeEvent"

const debugToken = LocalStorage.get("DEBUG_STORED_TOKEN")
const isLocalDev = LocalStorage.get("DEBUG_LOCAL_DEV")
interface FreshTokenResponse {
    accessToken: string
}

const fetchTokenFromNative = () =>
    new Promise<string>(resolve => {
        const handleFreshToken = ({ accessToken }: FreshTokenResponse) => {
            resolve(accessToken)
        }

        // Get token from native
        NativeEventBridge.listen(MenyNativeEvent.FreshAccessToken, handleFreshToken, true)

        if (debugToken) {
            DebugLogger.log(
                "Load-order-debug: Found DEBUG_STORED_TOKEN... simulating FAST RESPONSE...",
            )
            setTimeout(() => {
                DebugLogger.log("Load-order-debug: Found DEBUG_STORED_TOKEN:", debugToken)
                NativeEventBridge.broadcastNative(MenyNativeEvent.FreshAccessToken, {
                    accessToken: debugToken,
                })
            }, 200)
            return
        } else if (isLocalDev) {
            DebugLogger.log(
                "Load-order-debug: Found DEBUG_LOCAL_DEV... simulating FAST not logged in response...",
            )
            setTimeout(() => {
                NativeEventBridge.broadcastNative(MenyNativeEvent.FreshAccessToken, {
                    accessToken: "",
                })
            }, 200)
            return
        }
        DebugLogger.log("Load-order-debug: NO DEBUG_STORED_TOKEN, using normal auth")

        NativeEventBridge.broadcastNative(MenyNativeEvent.RefreshAccessToken, { forceRefresh: 0 })
    })

export default fetchTokenFromNative
